import { createTheme } from '@mui/material'

export const theme = createTheme({
    palette: {
        primary: {
            main: '#E84F27'
        },
        secondary: {
            main: '#FEE57B'
        },
        success: {
            main: '#D5E6C3'
        }
    },
    typography: {
        fontFamily: "'Raleway', 'sans-serif'",
        button: {
            textTransform: 'none'
        }
    }
})
